/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BeautyCosmeticsPerfumeIcon16Light } from './BeautyCosmeticsPerfumeIcon16Light';
import { BeautyCosmeticsPerfumeIcon16Regular } from './BeautyCosmeticsPerfumeIcon16Regular';
import { BeautyCosmeticsPerfumeIcon16Solid } from './BeautyCosmeticsPerfumeIcon16Solid';
import { BeautyCosmeticsPerfumeIcon20Light } from './BeautyCosmeticsPerfumeIcon20Light';
import { BeautyCosmeticsPerfumeIcon20Regular } from './BeautyCosmeticsPerfumeIcon20Regular';
import { BeautyCosmeticsPerfumeIcon20Solid } from './BeautyCosmeticsPerfumeIcon20Solid';
import { BeautyCosmeticsPerfumeIcon24Regular } from './BeautyCosmeticsPerfumeIcon24Regular';
import { BeautyCosmeticsPerfumeIcon24Solid } from './BeautyCosmeticsPerfumeIcon24Solid';
import { BeautyCosmeticsPerfumeIcon32Regular } from './BeautyCosmeticsPerfumeIcon32Regular';
import { BeautyCosmeticsPerfumeIcon64Regular } from './BeautyCosmeticsPerfumeIcon64Regular';
var sizes = {
    16: {
        light: BeautyCosmeticsPerfumeIcon16Light,
        regular: BeautyCosmeticsPerfumeIcon16Regular,
        solid: BeautyCosmeticsPerfumeIcon16Solid,
    },
    20: {
        light: BeautyCosmeticsPerfumeIcon20Light,
        regular: BeautyCosmeticsPerfumeIcon20Regular,
        solid: BeautyCosmeticsPerfumeIcon20Solid,
    },
    24: {
        regular: BeautyCosmeticsPerfumeIcon24Regular,
        solid: BeautyCosmeticsPerfumeIcon24Solid,
    },
    32: {
        regular: BeautyCosmeticsPerfumeIcon32Regular,
    },
    64: {
        regular: BeautyCosmeticsPerfumeIcon64Regular,
    },
};
export var BeautyCosmeticsPerfumeIcon = forwardRef('BeautyCosmeticsPerfumeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
